import { render, staticRenderFns } from "./switchButton.vue?vue&type=template&id=56990d82&"
import script from "./switchButton.vue?vue&type=script&lang=js&"
export * from "./switchButton.vue?vue&type=script&lang=js&"
import style0 from "./switchButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports